<template>

    <div class="container">

        <div class="handle-box-search">

            <el-row class="head-search">


                <el-col :span="8" style="margin-bottom: 10px;">
                    <span class="title">用户手机号:</span>

                    <el-input v-model="search_data.consumer_phone" placeholder="请输入用户手机号" maxlength="11"
                        class="handle-input mr10" @keyup.enter.native="searchuserCardList"></el-input>
                </el-col>
                <el-col :span="8">
                    <span class="title">畅行卡名称:</span>
                    <!-- 搜索名称 -->
                    <el-input v-model="search_data.name" placeholder="请输入畅行卡名称" class="handle-input mr10"
                        @keyup.enter.native="searchcardLists"></el-input>
                </el-col>

                <el-col :span="8" style="margin-bottom: 10px;">
                    <span class="title">状态:</span>

                    <el-select v-model="search_data.status" placeholder="请选择" clearable>
                        <el-option label="失效" value="0">
                        </el-option>
                        <el-option label="生效" value="1">
                        </el-option>
                    </el-select>
                </el-col>

            </el-row>



            <el-row class="head-search">


                <el-col :span="24" style="margin-bottom: 10px;">
                    <span class="title">购买时间:</span>

                    <el-date-picker v-model="search_time" type="datetimerange" range-separator="-"
                        start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange" style="width: 350px;">
                    </el-date-picker>
                </el-col>



            </el-row>

            <el-button type="primary" icon="el-icon-search" @click="searchuserCardList">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button v-if="loading" icon="el-icon-loading" disabled></el-button>
            <el-button @click="toExport" v-else>导出</el-button>
            <div style="width: 500px; margin: 10px auto;" v-if="progress_show">

                <el-progress :percentage="progress_data"></el-progress>
                <i class="el-icon-loading"></i>
                正在导出...

            </div>
        </div>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
            @selection-change="handleSelectionChange">

            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="card_name" label="名称" min-width="100">
            </el-table-column>

            <el-table-column prop="order_no" label="订单编码" min-width="180">
            </el-table-column>


            <el-table-column prop="consumer_phone" label="用户手机号">
            </el-table-column>


            <el-table-column prop="city" label="城市">
            </el-table-column>

            <el-table-column prop="status" label="生效状态">
                <template slot-scope="scope">
                    <span>
                        {{scope.row.status==1?'生效':'失效'}}
                    </span>
                </template>
            </el-table-column>

            <el-table-column prop="buy_time" label="创建时间">
            </el-table-column>

            <el-table-column prop="enable_time" label="生效时间">
            </el-table-column>

            <el-table-column prop="expire_time" label="过期时间">
            </el-table-column>

            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" @click="toDetalis(scope.row.card_details_code)">查看</el-button>
                </template>
            </el-table-column>

        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>


        <!-- 详情组件 -->
        <detailsC :isShow="details_isShow" :data="card_details_code"></detailsC>

    </div>

</template>

<script>
    import detailsC from './details.vue';
    import bus from '@/components/common/bus.js';
    var _this;
    export default {
        components: {
            detailsC
        },

        data() {
            return {

                excelData: [],

                excelHead: [],

                progress_show: false,
                progress_data: 0,

                loading: false,
                search_time: '',

                details_isShow: false,

                card_details_code: '',

                // 存放表格数据
                tableData: [],

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    name: '',
                    status: '',
                    buy_fixed_array: '',
                    consumer_phone: '',
                    card_details_code_array: ''
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    },

                },
            };
        },
        created() {
            _this = this;
            bus.$on('btnStatus', (msg) => {
                _this.progress_show = msg;
            });
            _this.userCardList()
        },

        methods: {


            // 导出
            toExport() {

                _this.progress_show = true;
                _this.search_data.page = 1;
                _this.getExcelData();


            },

            getExcelData() {

                _this.$post(
                    "/card/userCardList",
                    _this.search_data
                ).then(res => {

                    _this.progress_show = true;

                    if (this.$route.path == '/purchaseHistory') {


                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.length; i++) {
                            console.log(res.data[i].order_code);
                            _this.excelData.push({
                                'card_name': res.data[i].card_name,
                                'order_no': res.data[i].order_no,
                                'consumer_phone': res.data[i].consumer_phone,
                                'city': res.data[i].city,
                                'status': res.data[i].status == '1' ? '生效' : '失效',
                                'buy_time': res.data[i].buy_time,
                                'enable_time': res.data[i].enable_time,
                                'expire_time': res.data[i].expire_time


                            });


                        }



                        if (_this.search_data.page * _this.search_data.limit < res.count) {

                            _this.search_data.page = _this.search_data.page + 1;

                            _this.progress_data = Math.floor((_this.search_data.page * _this.search_data.limit / res.count) * 100);

                            _this.getExcelData();

                        } else {

                            // console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;


                        }

                    } else {

                        _this.progress_show = false;
                        _this.progress_data = 0;

                    }



                }).catch((err) => {

                })

            },


            // 导出excel方法
            exportData() {
                const {
                    export_json_to_excel
                } = require('@/vendor/Export2Excel');
                const tHeader = ['名称', '订单编码', '用户手机号', '城市', '生效状态', '创建时间', '生效时间', '过期时间'];


                const filterVal = ['card_name', 'order_no', 'consumer_phone', 'city', 'status', 'buy_time', 'enable_time', 'expire_time'
                ];
                const list = this.excelData;
                const data = this.formatJson(filterVal, list);
                let time = new Date();
                console.log(time);
                console.log(time.toLocaleDateString());
                export_json_to_excel(tHeader, data, '畅行卡购买记录'+time.toLocaleDateString());
            },

            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]));
            },

            // 全选或多选
            handleSelectionChange(val) {
                this.multipleSelection = val;
                console.log(this.multipleSelection);

                var datalist = [];

                for (var i in val) {

                    datalist.push(val[i].card_details_code);

                }
                _this.search_data.card_details_code_array = datalist;
                console.log(datalist);

            },

            toDetalis(code) {
                console.log(111);
                _this.details_isShow = !_this.details_isShow;
                _this.card_details_code = code;

            },


            timeChange(val) {
                if (val !== null) {
                    _this.search_data.buy_fixed_array = JSON.stringify(['between'].concat(val));

                } else {
                    _this.search_data.buy_fixed_array = ''
                }

            },
            searchuserCardList() {


                _this.search_data.page = 1;
                _this.userCardList();

            },
            // 搜索司机日志列表
            userCardList() {
                _this.$post(
                    "/card/userCardList",
                    _this.search_data,
                    _this.search_rules
                )
                    .then(res => {


                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;

                    }).catch((err) => {

                    })
            },
            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.userCardList();

            },


            // 刷新按钮
            refresh() {
                this.$router.go(0);
            },

        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-form-item.el-form-item--small {
        width: 100%;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
    }

    .el-form-item__content span {
        display: inline-block;
        width: 100%;
        word-wrap: break-word;
        white-space: normal;
    }
</style>